import React from "react";
import { useDropzone } from "react-dropzone";
import { Stack, Typography, Button } from "@mui/material";
import { CloudUploadOutlined } from "@mui/icons-material";
import SelectFileButton from "./SelectFileButton";
import UploadFileIcon from '@mui/icons-material/UploadFile';

type FileInputProps = {
  handleFileSelect: (v: File) => void;
};

export default function FileInput({ handleFileSelect }: FileInputProps) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
      "application/vnd.ms-excel": [".xls"],
      "text/csv": [".csv"], // ✅ Add CSV support
    },
    multiple: false,
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) handleFileSelect(file);
    },
  });

  return (
    <div
      {...getRootProps()}
      style={{
        flex: 1,
        border: "2px dashed #ccc",
        borderRadius: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        padding: 20
      }}
    >
      <input {...getInputProps()} />
      <Stack alignItems="center" spacing={1}>
        <CloudUploadOutlined style={{ fontSize: 64, color: "#888" }} />
        <Typography variant="body1">
          {isDragActive
            ? "Drop the file here..."
            : "Drag and drop a CSV or Excel file here, or click to browse"}
        </Typography>
        <Button startIcon={<UploadFileIcon />} variant="contained">Choose File</Button>
      </Stack>
    </div>
  );
}
